import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  constructor() {
  }

  transform(value: number | null): string {
    if (_.isNil(value))
      return "";

    let unitLevel = 0;
    let currentValue = value;
    while (currentValue >= 1000 && unitLevel < 8) {
      currentValue = currentValue / 1000;
      unitLevel++;
    }

    let unit = this.getUnit(unitLevel);

    return `${currentValue.toFixed(2)} ${unit}`;
  }

  private getUnit(unitLevel: number): string {
    switch (unitLevel) {
      case 0:
        return 'B';
      case 1:
        return 'KB';
      case 2:
        return 'MB';
      case 3:
        return 'GB';
      case 4:
        return 'TB';
      case 5:
        return 'PB';
      case 6:
        return 'EB';
      case 7:
        return 'ZB';
      default:
        return 'YB';
    }
  }
}
